import { Component } from '@angular/core';

@Component({
    selector: 'app-no-access',
    template: '<h2>You are not authorised to use this product.</h2>'
})

export class NoAccessComponent {

}



// WEBPACK FOOTER //
// ./src/app/shared/components/no-access.component.ts